export const environment = {
  production: false,
  environment: 'dev',
  sentryDsn: '',
  defaultOrigin: 'client-dev',
  internalOrigin: 'client-internal-dev',
  persona: 'assistant-ta',
  chatConfiguration: 'dev',
  apiUrl: 'https://api-dev.sparringpartner.digitalevoordeur.amsterdam',
  surveyFollowUpUrl: '',
  inactivityMs: 10 * 60 * 1000,
  countdownSecs: 300,
  productionClientUrl: 'https://client.sparringpartner.digitalevoordeur.amsterdam/',
};
